import { useContext } from 'react';
import { OnboardingProcessContext } from '@context/OnboardingProcessProvider';

export default function useOnboardingProcess() {
  return useContext(OnboardingProcessContext);
}
